<template>
  <b-card class="dashboard-leaderboard" :key="leaderboard.id" no-body>
    <b-card-header class="d-none d-md-block">
      <b-row>
        <b-col cols="8"><b class="header">{{ leaderboard.name || 'Leaderboard'}}</b></b-col>
        <b-col cols="4" v-if="leaderboard.endDate">
          <span class="match-label bg-primary-a1 text-primary float-right">
            {{ $t('leaderboards.ends-on', { endDate: formatDate(leaderboard.endDate, 'DD/MMM') }) }}
          </span>
        </b-col>
      </b-row>
    </b-card-header>

    <b-card-body class="p-0">
      <div class="d-flex flex-row justify-content-start align-items-center px-3" v-if="!isRecruiter">
        <span class="points-collected text-primary mr-1">{{ currentScore }}</span>
        {{ isRaffleMode ? 'tickets' : 'points' }} earned
      </div>

      <router-link tag="div" class="d-flex flex-row flex-wrap justify-content-center align-items-center cursor-pointer my-3"
        :to="{ name: 'LeaderboardShow', params: { leaderboardID: leaderboard.id }}" v-if="leaderboard && leaderboard.prizes">
        <template v-for="i in [ 'first', 'second', 'third' ]">
          <b-img v-if="leaderboard.prizes[i] && leaderboard.prizes[i].image && leaderboard.prizes[i].image.fileLocation" class="border img-fit-cover m-1"
            :src="leaderboard.prizes[i].image.fileLocation" :alt="leaderboard.prizes[i].title" height="150" width="150"/>
        </template>
      </router-link>
    </b-card-body>

    <b-card-footer class="text-center" v-if="leaderboard.hidden">
      <leaderboard-details-modal :id="`modal-${leaderboard.id}-${_uid}`" :leaderboard="leaderboard" />
      <a href="#" style="cursor: pointer" @click.prevent="() => false" v-b-modal="`modal-${leaderboard.id}-${_uid}`">
        {{ $t(isRaffleMode ? 'leaderboards.scores.how-to-earn-tickets' : 'leaderboards.scores.how-to-earn-points') }}
      </a>
    </b-card-footer>
    <b-card-footer class="text-center" v-else>
      <router-link :to="{ name: 'LeaderboardShow', params: { leaderboardID: leaderboard.id }}">
        {{ $t('leaderboards.ctas.view-leaderboard') }}
      </router-link>
    </b-card-footer>

  </b-card>
</template>

<script>
import LeaderboardDetailsModal from '@/modals/leaderboard-details-modal';
import { formatDate } from '@src/filters';
import { mapRoot } from '@src/mixins/root';

export default {
  props: {
    leaderboard: {
      type: Object,
      validate: p => p && p.id,
    },
  },
  components: {
    LeaderboardDetailsModal,
  },
  computed: {
    ...mapRoot([ 'user', 'isRecruiter' ]),
    isRaffleMode() {
      const { raffleMode } = this.leaderboard || {};
      return raffleMode === true;
    },
    currentScore() {
      const { type, departmentScores, userScore, userScores } = this.leaderboard || {};
      const { id: userID, departments: [ { id: departmentID } = {} ] = [] } = this.user || {};

      if (type === 'INDIVIDUALS' && userScore) {
        return userScore.total || 0;
      } else if (type === 'DEPARTMENTS' && departmentScores && departmentID && Array.isArray(departmentScores.edges)) {
        const { total } = departmentScores.edges.find(({ entry: { id } = {} }) => departmentID === id) || {};
        return total || 0;
      } else if (type === 'INDIVIDUALS' && userScores && userID && Array.isArray(userScores.edges)) {
        const { total } = userScores.edges.find(({ entry: { id } = {} }) => userID === id) || {};
        return total || 0;
      } else {
        return 0;
      }
    },
    totalScore() {
      const { total } = this.leaderboard || {};
      return total || 0;
    },
  },
  methods: {
    formatDate,
  },
};
</script>

<style lang="scss">
.dashboard-leaderboard {
  .leaderboard-header-img {
    width: 100%;
    margin-bottom: 2rem;
  }

  .card-header {
    background: white;
    .header {
      vertical-align: -webkit-baseline-middle;
    }
    // font-size: 1.1rem
  }
  .card-body {
    font-size: 0.9rem;
  }
  .match-label {
    width: inherit;
    height: inherit;
    padding: 5px;
  }
  .card-footer {
    background-color: inherit;
  }

  .employee {
    // .data-row {
    //   .position, .department-name, .
    // }
  }
  .data-row {

    .score {
      text-align: right;
      display: block;
    }
    .department-icon {
      font-size: 1.5em;
      width: 30px;
    }
    .position, .score, .department-name {
      display: flex;
      justify-content: center;
      flex-direction: column;
    }
    .department-name {
      font-weight: bold;
    }

    .position {
      margin-right: 1rem;
    }
    margin-bottom: 1.5rem;
  }

  .points-collected {
    font-size: 2.5em;
    font-weight: 700;
  }

  .card-group {
    flex-flow: row wrap;
  }

  .prize-item {
    flex: 1 0 0%;
    margin-bottom: 0;
    text-align: center;

    h4 {
      text-align: center;
      font-weight: 700;
    }
    .prize-img {
      margin: 5px 0;
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/dashboard-leaderboard.vue